import React, { useEffect, useRef } from 'react';

function AdBanner({ adSlot, format = 'auto' }) {
  const adRef = useRef(null);
  
  useEffect(() => {
    // Google AdSense 코드 작동 방식
    // 실제 Google AdSense 계정이 필요합니다
    if (window.adsbygoogle && adRef.current) {
      try {
        // Push ad to Google AdSense
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (e) {
        console.error('AdSense 오류:', e);
      }
    }
  }, []);

  return (
    <div className="ad-container">
      {/* 실제 AdSense 사용 시 아래 코드 주석 해제 */}
      {/* 
      <ins className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client="ca-pub-XXXXXXXXXXXXXXXX" // 실제 AdSense 계정 ID로 대체
        data-ad-slot={adSlot}
        data-ad-format={format}
        data-full-width-responsive="true"
        ref={adRef}></ins>
      */}
      
      {/* 개발 중에는 광고 플레이스홀더 표시 */}
      <div className="ad-placeholder p-3 bg-light border">
        <p className="mb-0 text-center">광고 영역 ({format} 형식)</p>
      </div>
    </div>
  );
}

export default AdBanner;